/*------------------------------------*\
    BREADCRUMBS
\*------------------------------------*/
class Breadcrumbs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let breadcrumbsList = document.querySelector('.js-breadcrumbs__list');
        let breadcrumbsWidth = breadcrumbsList.scrollWidth;

        // Scroll the breadcrumbs all the way to the right
        breadcrumbsList.scrollLeft = breadcrumbsWidth;

        // If the breadcrumbs are scrolled more than 10px to the right, add a nice little gradient

        breadcrumbsList.addEventListener('scroll', function() {
            if(this.scrollLeft < 10) {
                self.elem.classList.remove('is-faded');
            } else {
                self.elem.classList.add('is-faded');
            }
        });
    }
}

export default Breadcrumbs;
